import supabaseClient from '@/api/supabaseClient.ts';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type ToggleVisibilityParams = {
  user_id: string;
  is_hidden: boolean;
};

const useAdminToggleCarerVisibility = () => {
  const queryClient = useQueryClient();

  const mutationFn = async ({ user_id, is_hidden }: ToggleVisibilityParams) => {
    const { data, error } = await supabaseClient
      .from('users')
      .update({ is_hidden })
      .eq('id', user_id)
      .select()
      .single();

    if (error) {
      console.error('Error toggling carer visibility:', error);
      throw new Error(error.message);
    }

    return data;
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-carers'] });
    },
  });
};

export default useAdminToggleCarerVisibility;
